import store from "../../store/store";
import {changeShadowState} from "../../actions/shadowsActions";
import {myID} from "../../libs/generateID";
import {MessageTypes} from "../../constans/mqttMessages";
import {notify} from "reapop";
import DevTypes from "@wesstron/utils/Api/constants/devTypes";

export const INTERVAL_TIME = 10000;

export function fakeStartSendingDeviceState(devices) {
    console.log(devices, "fakeStartSendingDeviceState");
    const map = new Map();
    devices.forEach((dev) => {
        if (dev?.DevType === DevTypes.CAMERA) {
            const shadow = getShadow();
            map.set(dev.DevID, shadow);
        }
    });
    store.dispatch(changeShadowState(map));
}

export function fakeCreateAndSendMessageObject(
    ClientID,
    GatewayID,
    LocalUserID,
    DeviceID,
    Command,
    data = undefined,
    notification = undefined,
    onSuccess = undefined,
    onError = undefined,
    onSend = undefined
) {
    const id = myID();
    const message = {
        MsgId: id,
        PktType: MessageTypes.REQUEST,
        DeviceId: DeviceID,
        RTime: new Date().getTime(),
        Command: Array.isArray(Command) ? Command : [Command],
        CData: {},
        Priority: 69,
    };
    if (data) {
        message.CData = data;
    }
    if (notification && notification.success) {
        store.dispatch(
            notify({
                ...notification.loading,
                ...notification.success,
            })
        );
    }
    if (onSuccess) setTimeout(() => onSuccess(), 250);
    return id;
}

const getShadow = () => {
    return {
        metadata: {},
        streamData: {
            closeReason: null,
            rtspLink: "rtsp:://demo2:demo1@fetura.com.pl/cam/monitor/3/7",
            startTime: new Date().getTime(),
            viewers: {demo: new Date().getTime()},
        },
        streamObject: true,
    };
};
